
// Promos.jsx (updated)
import React, { useCallback, useEffect, useRef, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { Container, AppBar, Dialog, Grid, Slide, Toolbar, Typography } from '@mui/material';
import { Close, ConfirmationNumber } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { Widget } from '../../components/widget/Widget';
import CommonTable from '../../components/dateTimePicker/table/NewTable';
import { getAllPromos, deletePromo, updatePromo } from '../../redux/actions/promocode.actions';
import CommonModal from '../../components/Comman/deleteModal';
import { Button } from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function Promos(props) {
	const { promocodes, openDialog, handleDialog } = props;
	const [isUpdated, setIsUpdated] = useState(false);
	const [searchTerm, setSearchTerm] = useState('');
	const debounceTimeout = useRef(null);
	const [open, setOpen] = useState(false);
	const [deletedId, setDeletedId] = useState(null);

	const dispatch = useDispatch();
	const [currentPage, setCurrentPage] = useState(1);
	// console.log(promocodes, 'promocodes');
	const rows = promocodes?.data
		? promocodes?.data.map((item) => ({
			...item,
			id: item?.client_promo_id,
			updateId: item?.id,
		}))
		: [];


	const columns = [
		{ header: 'ID', accessor: 'id' },
		{ header: 'Promo Code', accessor: 'promo_code' },
		{ header: 'Consumption Type', accessor: 'consumption_type' },
		{ header: 'Consumption Count', accessor: 'consumption_count' },
		{ header: 'Total Count', accessor: 'total_count' },
		{ header: 'Validity', accessor: 'expires_at' },
	];

	useEffect(() => {
		if (isUpdated) {
			dispatch(getAllPromos(sessionStorage.getItem('promoId'), currentPage));
			setIsUpdated(false);
		}
	}, [dispatch, isUpdated]);

	const handleCloseDialog = () => {
		handleDialog(false);
	};
	const handleSave = async (updatedRow) => {
		try {
			const response = await dispatch(updatePromo(updatedRow));
			if (response.success === true) {
				dispatch(getAllPromos(sessionStorage.getItem('promoId')));
			}
		} catch (error) {
			console.error('Error updating promo code:', error);
		}
	};

	const handleDelete = (id) => {
		setOpen(true);
		setDeletedId(id);
	};

	const handleModalDelete=()=>{
		const payload = { client_promo_id: deletedId };
		dispatch(deletePromo(payload));
		setOpen(false);
	}
	//pagination and search
	const handlePageChange = (_, pageNumber) => {
		setCurrentPage(pageNumber);
		dispatch(getAllPromos(sessionStorage.getItem('promoId'), pageNumber));
	};


	const handleSearch = useCallback((e) => {
		const value = e;
		setSearchTerm(value);
		if (debounceTimeout.current) {
			clearTimeout(debounceTimeout.current);
		}
		debounceTimeout.current = setTimeout(() => {
			dispatch(getAllPromos(sessionStorage.getItem('promoId'), 1, value));
		}, 1500);
	}, []);





	return (
		<Dialog fullScreen open={openDialog} onClose={handleCloseDialog} TransitionComponent={Transition} >
			<AppBar sx={{ position: 'relative' }}>
				<Toolbar>
					<IconButton edge="start" color="inherit" onClick={handleCloseDialog} aria-label="close">
						<Close />
					</IconButton>
					<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
						Promo Codes
					</Typography>
				</Toolbar>
			</AppBar>
			<Container
				sx={{
					width: '100%',
					height: '100%',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}
				maxWidth="lx"
			>
				<Grid container direction="column" justifyContent="center" alignItems="center" width={'100%'} >
					<Widget
						heading="TOTAL"
						icon={<ConfirmationNumber fontSize="large" color="secondary" />}
						content={promocodes?.totalRecords}
					/>
					<Box style={{ width: '100%' }}>
						<CommonTable
							rowsPerPage={10}
							data={rows}
							columns={columns}
							onEdit={(row) => console.log('Editing:', row)}
							onSave={handleSave}
							onCancel={(id) => console.log('Canceled edit:', id)}
							onDelete={handleDelete}
							totalPage={promocodes?.totalRecords}
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							handlePageChange={handlePageChange}
							searchTerm={searchTerm}
							setSearchTerm={setSearchTerm}
							handleSearch={handleSearch}
						/>
					</Box>
				</Grid>
			</Container>
			<CommonModal
				open={open}
				onClose={() => setOpen(false)}
				title={`Are you sure you want to delete this promo code?  ${deletedId}`}
				actions={
					<>
						<Button onClick={() => setOpen(false)} variant='contained'>Cancel</Button>
						<Button variant="contained" onClick={handleModalDelete} color='error'>
							Confirm
						</Button>
					</>
				}
			></CommonModal>
		</Dialog>
	);
}
